import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Filter, Plus, User, CheckCircle2, AlertCircle, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
const volunteersData = [{
  id: 1,
  name: 'Sarah Jenkins',
  role: 'Medical Lead',
  station: 'Finish Line Medical',
  time: '05:30 - 14:00',
  status: 'Verified',
  checkIn: 'Checked In'
}, {
  id: 2,
  name: 'Marcus Chen',
  role: 'Water Station Captain',
  station: 'Water Station 1',
  time: '06:00 - 10:00',
  status: 'Verified',
  checkIn: 'Checked In'
}, {
  id: 3,
  name: 'Elena Rodriguez',
  role: 'Course Marshal',
  station: 'Route Marshal Zone A',
  time: '06:30 - 12:30',
  status: 'Pending',
  checkIn: 'Pending'
}, {
  id: 4,
  name: 'David Kim',
  role: 'Registration Staff',
  station: 'Registration Desk',
  time: '04:00 - 10:00',
  status: 'Expired',
  checkIn: 'Pending'
}, {
  id: 5,
  name: 'Aisha Patel',
  role: 'Logistics Coordinator',
  station: 'Parking & Logistics',
  time: '04:00 - 16:00',
  status: 'Verified',
  checkIn: 'Checked In'
}, {
  id: 6,
  name: 'Tom Wilson',
  role: 'Media Liaison',
  station: 'Media Tent',
  time: '07:00 - 15:00',
  status: 'Verified',
  checkIn: 'Pending'
}];
export function Volunteers() {
  const [searchTerm, setSearchTerm] = useState('');
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-693">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-694">
        <div data-id="element-695">
          <h1 className="text-2xl font-display font-bold text-white mb-1" data-id="element-696">
            Volunteers
          </h1>
          <p className="text-[var(--muted)] text-sm" data-id="element-697">
            Manage and track your event workforce.
          </p>
        </div>
        <button className="bg-[var(--accent)] hover:bg-[#b3e622] text-black px-4 py-2 rounded-md font-semibold text-sm transition-colors flex items-center gap-2 self-start sm:self-auto" data-id="element-698">
          <Plus className="w-4 h-4" data-id="element-699" />
          Add Volunteer
        </button>
      </div>

      <div className="bg-[var(--surface)] border border-white/5 rounded-xl overflow-hidden" data-id="element-700">
        {/* Toolbar */}
        <div className="p-4 border-b border-white/5 flex flex-col sm:flex-row gap-4 justify-between items-center bg-white/[0.02]" data-id="element-701">
          <div className="relative w-full sm:w-72" data-id="element-702">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--muted)]" data-id="element-703" />
            <input type="text" placeholder="Search volunteers..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-[var(--bg)] border border-white/10 rounded-md pl-9 pr-4 py-1.5 text-sm text-white focus:outline-none focus:border-[var(--accent)]/50 transition-colors placeholder:text-[var(--muted)]" data-id="element-704" />
          </div>
          <div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-705">
            <button className="flex items-center gap-2 px-3 py-1.5 border border-white/10 rounded-md text-sm text-[var(--muted)] hover:text-white hover:bg-white/5 transition-colors" data-id="element-706">
              <Filter className="w-4 h-4" data-id="element-707" />
              Filter
            </button>
            <div className="text-sm text-[var(--muted)] px-2" data-id="element-708">
              {volunteersData.length} total
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-709">
          <table className="w-full text-left text-sm" data-id="element-710">
            <thead className="text-xs text-[var(--muted)] uppercase bg-white/[0.02] border-b border-white/5" data-id="element-711">
              <tr data-id="element-712">
                <th className="px-6 py-3 font-medium" data-id="element-713">Name</th>
                <th className="px-6 py-3 font-medium" data-id="element-714">Role & Station</th>
                <th className="px-6 py-3 font-medium" data-id="element-715">Shift</th>
                <th className="px-6 py-3 font-medium" data-id="element-716">Docs</th>
                <th className="px-6 py-3 font-medium" data-id="element-717">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5" data-id="element-718">
              {volunteersData.map((vol, i) => <motion.tr key={vol.id} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              delay: i * 0.05
            }} className="hover:bg-white/[0.02] transition-colors group" data-id="element-719">
                  <td className="px-6 py-4" data-id="element-720">
                    <Link to={`/dashboard/volunteers/${vol.id}`} className="flex items-center gap-3 group/link" data-id="element-721">
                      <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-[var(--muted)] group-hover/link:bg-[var(--accent)]/10 group-hover/link:text-[var(--accent)] transition-colors" data-id="element-722">
                        <User className="w-4 h-4" data-id="element-723" />
                      </div>
                      <span className="font-medium text-white group-hover/link:text-[var(--accent)] transition-colors" data-id="element-724">
                        {vol.name}
                      </span>
                    </Link>
                  </td>
                  <td className="px-6 py-4" data-id="element-725">
                    <div className="flex flex-col" data-id="element-726">
                      <span className="text-white" data-id="element-727">{vol.role}</span>
                      <span className="text-[var(--muted)] text-xs" data-id="element-728">
                        {vol.station}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-[var(--muted)]" data-id="element-729">{vol.time}</td>
                  <td className="px-6 py-4" data-id="element-730">
                    <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium ${vol.status === 'Verified' ? 'bg-[var(--success)]/10 text-[var(--success)]' : vol.status === 'Pending' ? 'bg-orange-400/10 text-orange-400' : 'bg-[var(--danger)]/10 text-[var(--danger)]'}`} data-id="element-731">
                      {vol.status === 'Verified' ? <CheckCircle2 className="w-3 h-3" data-id="element-732" /> : vol.status === 'Pending' ? <Clock className="w-3 h-3" data-id="element-733" /> : <AlertCircle className="w-3 h-3" data-id="element-734" />}
                      {vol.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-735">
                    <span className={`text-sm ${vol.checkIn === 'Checked In' ? 'text-[var(--success)]' : 'text-[var(--muted)]'}`} data-id="element-736">
                      {vol.checkIn}
                    </span>
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}